import { render, staticRenderFns } from "./ManagementUser.vue?vue&type=template&id=07364976&"
import script from "./ManagementUser.vue?vue&type=script&lang=ts&"
export * from "./ManagementUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports